import React from "react";

export default function Footer() {
  return (
    <div className="flex flex-wrap gap-x-2 justify-center items-center w-full py-2 text-xs text-app-muted">
      <span>© {new Date().getFullYear()} Empedance.</span>
      <span>All rights reserved.</span>
    </div>
  );
}
